module.exports = __webpack_public_path__ + "img/ertiga-xl7-blanco-estelar.330b8f8e.png";